var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"type":"is-primary"}},[_vm._v(" Click Me ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }